/* eslint-disable @typescript-eslint/no-empty-function */
import React, { Dispatch, SetStateAction, useState } from 'react';

import { DialogBox, PrintProgressLoader } from '@mummssoftware/common-ui';
import { createPortal } from 'react-dom';
import { PrintProgress } from '@mummssoftware/utils/api/Printing';
import { PrintInterface } from './PrintInterface';
import defaults from '../../translations/en.json';

type PrintInterfaceContextType = {
  setLoading: Dispatch<SetStateAction<boolean>> | (() => void);
  setProgress: Dispatch<SetStateAction<PrintProgress | null>> | (() => void);
};

export const PrintInterfaceContext = React.createContext<
  PrintInterfaceContextType
>({
  setLoading: () => {},
  setProgress: () => {},
});

export const PrintInterfaceDialog = ({
  open,
  handleClick,
  config,
  printConfigNames,
}: any) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [printProgress, setPrintProgress] = useState<PrintProgress | null>(
    null,
  );

  return (
    <PrintInterfaceContext.Provider
      value={{
        setLoading: setLoadingPrint,
        setProgress: setPrintProgress,
      }}
    >
      <DialogBox
        title={defaults.printTitle}
        disableBackdropClick
        open={open}
        handleClick={handleClick}
        fullWidth
        maxWidth="sm"
      >
        <PrintInterface config={config} printConfigNames={printConfigNames} />
      </DialogBox>
      {loadingPrint &&
        createPortal(
          <PrintProgressLoader
            progress={printProgress}
            sourceString="Print the Chart"
          />,
          document.getElementById('portal-container') || document.body,
        )}
    </PrintInterfaceContext.Provider>
  );
};
